import { Fetcher, camelToSnake, objectToFormData } from '@this/src/util';
import React from 'react';
import _ from 'lodash';
import { reportError } from '@this/lib/bugsnag';

interface VirtualCounterResponse {
  signed_in: {
    signed_in: boolean;
    arranger: {
      id: number;
      email: string;
      first_name: string;
      last_name: string;
      created_at: string;
      updated_at: string;
      invitation_token: string;
      invitation_created_at: string;
      invitation_sent_at: string;
      invitation_accepted_at: string;
      invitation_limit: string;
      invited_by_id: never;
      invited_by_type: never;
      invitations_count: number;
      service_id: string;
    };
  };
}

interface UserInput {
  lastName: string;
  firstName: string;
}

interface State extends UserInput {
  editNotice: string | null;
  submitting: boolean;
  editErrors: (string | string[])[];
  arrangerId?: number;
}

type UserInputHandler = (name: keyof UserInput) => (e: React.ChangeEvent<HTMLInputElement>) => void;

const expandErrors = ({ errors }: { errors: (string | string[])[] }) =>
  _.map(errors, error => {
    if (typeof error === 'string') {
      return error.split('\n').map(line => <p key={line}>{line}</p>);
    }
    return error[0];
  }).map((elm, i) => (
    <div className="error" key={i}>
      {elm}
    </div>
  ));

type Props = any;

export default class ArrangerUserEdit extends React.Component<Props, State> {
  state: State = {
    editNotice: null,
    submitting: false,
    editErrors: [],
    lastName: '',
    firstName: ''
  };

  componentDidMount() {
    this.initPromise();
  }

  initPromise = async () => {
    const result = await Fetcher.get<VirtualCounterResponse>('/arrangement/virtual_counter.json');
    this.setState({
      arrangerId: result.signed_in.arranger.id,
      lastName: result.signed_in.arranger.last_name,
      firstName: result.signed_in.arranger.first_name
    });
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({
      submitting: true,
      editErrors: [],
      editNotice: null
    });

    const params = this.stateToParamsWithKeys(['arrangerId', 'lastName', 'firstName']);
    try {
      await Fetcher.put('/arrangers/update_account', objectToFormData(params));
      this.setState({
        editErrors: [],
        editNotice: '変更を保存しました',
        submitting: false
      });
    } catch (error) {
      this.setState({ submitting: false });
      if (error.response.status === 400) {
        this.setState({ editErrors: error.response.data.errors });
      } else {
        this.setState({ editErrors: ['通信環境が不安定です。\n時間をおいてもう一度お試しください。'] });
      }
    }
  };

  stateToParamsWithKeys = (keys: ('arrangerId' | keyof UserInput)[]) => {
    const params: { [key: string]: string | number } = {};
    keys.forEach(key => {
      params[`arranger[${camelToSnake(key)}]`] = (this.state as any)[key];
    });
    return params;
  };

  change: UserInputHandler = name => e => {
    const rt = { [name]: e.target.value } as { [key in typeof name]: string };
    this.setState(rt);
  };

  render() {
    try {
      return (
        <div className="user-edit">
          <div className="content-body">
            <form onSubmit={this.handleSubmit}>
              <div className="user-edit__section">
                <label className="user-edit__left-label">氏名</label>
                <label className="user-edit__sub-label" htmlFor="lastName">
                  氏
                </label>
                <input
                  id="lastName"
                  type="text"
                  placeholder="例） 山田"
                  value={this.state.lastName}
                  className="user-edit__input-split"
                  onChange={this.change('lastName')}
                />
                <label className="user-edit__sub-label" htmlFor="firstName">
                  名
                </label>
                <input
                  id="firstName"
                  type="text"
                  placeholder="例） 一郎"
                  value={this.state.firstName}
                  className="user-edit__input-split"
                  onChange={this.change('firstName')}
                />
              </div>
              {this.state.editNotice && (
                <div className="user-edit__notice">
                  <div className="notice">{this.state.editNotice}</div>
                </div>
              )}
              <div className="user-edit__errors">{expandErrors({ errors: this.state.editErrors })}</div>
              {this.state.submitting ? (
                <img className="user-edit__loading" src="user-edit__loading" width={50} height={50} />
              ) : (
                <div className="user-edit__button">
                  <input type="submit" value="保存" />
                </div>
              )}
            </form>
          </div>
        </div>
      );
    } catch (e) {
      reportError(e);
      return null;
    }
  }
}
